module.exports = __webpack_public_path__ + "img/map_mobile_4.c065f87a.png";